import { Container } from '@ui/container'
import React, { type FC, type PropsWithChildren } from 'react'

const SectionTemplateDefault: FC<PropsWithChildren> = ({ children }) => (
  <div className="mb-10 mt-3 flex h-full w-full justify-center">
    <Container className="py-3">{children}</Container>
  </div>
)

export default SectionTemplateDefault
